import PodcastInfoCell, { PodcastInfoCellProps } from './PodcastInfoCell';

export default PodcastInfoCell;
export type { PodcastInfoCellProps };
